import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import Icon from '../../../components/AppIcon';
import TechnicianDetailModal from './TechnicianDetailModal';

const TechnicianRevenueChart = ({ data = [], loading = false, dateRange }) => {
  const [selectedTechnician, setSelectedTechnician] = useState(null);

  const formatCurrency = (value) => {
    return `$${value?.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  };

  const handleBarClick = (data) => {
    if (data && data?.technicianId) {
      setSelectedTechnician(data);
    }
  };

  return (
    <>
      <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
        <div className="flex items-center justify-between mb-4 md:mb-6">
          <div className="flex items-center gap-2">
            <Icon name="Users" size={24} className="text-primary" />
            <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
              Ingresos por Técnico
            </h2>
          </div>
          <p className="text-xs text-muted-foreground">
            Click en las barras para ver detalles
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center items-center h-64">
            <Icon name="Loader2" className="w-8 h-8 text-blue-600 animate-spin" />
          </div>
        ) : data?.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-64">
            <Icon name="UserX" size={48} className="text-muted-foreground mb-2" />
            <p className="text-sm caption text-muted-foreground">
              No hay datos de técnicos disponibles
            </p>
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={350}>
            <BarChart data={data} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
              <XAxis 
                dataKey="technicianName" 
                stroke="#6b7280"
                style={{ fontSize: '12px' }}
                angle={-45}
                textAnchor="end"
                height={100}
              />
              <YAxis 
                tickFormatter={formatCurrency}
                stroke="#6b7280"
                style={{ fontSize: '12px' }}
              />
              <Tooltip 
                formatter={(value) => [formatCurrency(value), 'Ingresos']}
                contentStyle={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #e5e7eb',
                  borderRadius: '8px',
                  padding: '8px 12px'
                }}
              />
              <Legend />
              <Bar 
                dataKey="totalRevenue" 
                fill="#3b82f6" 
                name="Ingresos Totales"
                radius={[8, 8, 0, 0]}
                onClick={handleBarClick}
                cursor="pointer"
              />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>

      {selectedTechnician && (
        <TechnicianDetailModal
          technician={selectedTechnician}
          dateRange={dateRange}
          onClose={() => setSelectedTechnician(null)}
        />
      )}
    </>
  );
};

export default TechnicianRevenueChart;